<div class="py-2.5 px-7">
  <app-section-header
    [title]="'Admin - Manage Authors'"
    [preserveQueryParam]="true"
  ></app-section-header>

  <div class="pt-2.5 border-b border-project-200">
    <h2 class="my-4 text-xl font-bold font-montserrat text-project-500">
      Add New Author
    </h2>
    <div class="flex flex-wrap items-center pt-2">
      <label class="px-4 text-base font-normal font-montserrat">Name:</label>
      <mat-form-field
        appearance="outline"
        [floatLabel]="'never'"
        class="w-1/4 author_search-box"
        title="Please fill out this field"
      >
        <input
          type="text"
          matInput
          [formControl]="newAuthorName"
          (keyup.enter)="!isSaveDisabled && saveAuthor(newAuthorName.value, '')"
        />
        <button mat-icon-button matSuffix [disabled]="isSaveDisabled">
          <mat-icon
            class="ml-2 hover:text-project-300"
            (click)="saveAuthor(newAuthorName.value, '')"
            >save</mat-icon
          >
        </button>
      </mat-form-field>
      <div
        *ngIf="isCheckingNameDuplication"
        class="flex items-center px-4 py-2 space-x-4 text-sm italic animate-pulse"
      >
        <span class="font-montserrat">Checking name validity...</span>
        <mat-spinner color="primary" diameter="20" class="px-4"> </mat-spinner>
      </div>
    </div>
    <h3 class="font-montserrat" *ngIf="isDuplicateAuthor">
      That author already exists, please use the existing author or use a
      different name.
    </h3>
  </div>
  <div class="flex items-center justify-between pt-2">
    <h2 class="my-4 text-xl font-bold font-montserrat text-project-500">
      Existing Authors
    </h2>
    <mat-form-field
      [floatLabel]="'never'"
      appearance="outline"
      class="w-1/4 author_search-box"
    >
      <input
        type="text"
        matInput
        placeholder="Search authors..."
        [formControl]="selectedAuthorName"
        (keyup.enter)="searchAuthor(selectedAuthorName.value)"
      />
      <mat-icon
        matSuffix
        *ngIf="selectedAuthorName.value"
        title="Clear Search"
        class="float-left ml-2 text-xl hover:text-project-300"
        (click)="clearAuthorNameValue()"
        >close</mat-icon
      >
      <mat-icon
        matSuffix
        class="float-right ml-2 text-xl hover:text-project-300"
        title="Search"
        >search</mat-icon
      >
    </mat-form-field>
  </div>

  <div class="mat-elevation-z0">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="w-full max-w-full mat-elevation-z0 author__table font-montserrat"
      matSortActive="lastModifiedDateTime"
      matSortDirection="desc"
    >
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let author" class="py-3">
          <a color="primary" [routerLink]="['./', author.id]">{{
            author.name
          }}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="Location">
        <th mat-header-cell *matHeaderCellDef>Location</th>
        <td mat-cell *matCellDef="let author" class="py-3">
          {{ author.location }}
        </td>
      </ng-container>
      <ng-container matColumnDef="CreatedOn">
        <th mat-header-cell *matHeaderCellDef>Created On</th>
        <td mat-cell *matCellDef="let author" class="py-3">
          <mat-icon inline class="px-1">access_time</mat-icon>
          {{ author.created | date : "dd/MM/yyyy - HH:mm" }}
        </td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="px-4 py-3 border-t bg-project-600 border-t-project-700"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div
      class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
    >
      <div>
        <button
          class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100"
          (click)="loadAuthors()"
          title="Refresh"
        >
          <i class="icon icon-refresh"></i>
        </button>
        <mat-form-field
          [floatLabel]="'never'"
          class="w-16 text-sm leading-[0.99rem] author__page-select"
          appearance="outline"
          title="Number of entries per page"
        >
          <mat-select [formControl]="pageSizeFilter">
            <mat-option *ngFor="let page of pagingOptions" [value]="page">
              {{ page }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="font-montserrat">per page</span>
      </div>
      <div>
        <button
          class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          [disabled]="!dataSource?.paginator?.hasPreviousPage()"
          (click)="cmsPaginationService.previousPage(dataSource)"
        >
          Previous
        </button>
        <button
          *ngFor="let num of cmsPaginationService.pageNumbers"
          class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
          (click)="cmsPaginationService.selectPage(dataSource, num)"
          [disabled]="cmsPaginationService.isActivePage(dataSource, num)"
          [ngClass]="{
            'author__page-button--current': cmsPaginationService.isActivePage(
              dataSource,
              num
            )
          }"
        >
          {{ num }}
        </button>
        <button
          class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          (click)="cmsPaginationService.nextPage(dataSource)"
          [disabled]="!dataSource?.paginator?.hasNextPage()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
  <mat-paginator
    [pageSizeOptions]="[10, 25, 50, 100]"
    class="invisible"
  ></mat-paginator>
</div>
